import { render, staticRenderFns } from "./KT-FilterAccordion.vue?vue&type=template&id=42d70dfb&"
import script from "./KT-FilterAccordion.vue?vue&type=script&lang=js&"
export * from "./KT-FilterAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports